// Contours.js — the site's signature graphic.
// Layered contour lines: topography (earth / sustainability) that read
// equally as data curves. A single pulse travels the mid contour.
import React from 'react';

const paths = [
  'M0,300 C120,260 200,320 320,280 C440,240 520,300 640,255 C760,210 840,270 960,235',
  'M0,260 C130,215 210,275 330,235 C450,195 530,255 650,210 C770,168 850,225 960,190',
  'M0,220 C140,172 220,230 340,190 C460,152 540,210 660,166 C780,126 860,180 960,148',
  'M0,180 C150,130 230,185 350,147 C470,110 550,165 670,124 C790,86 870,136 960,106',
  'M0,140 C160,90 240,142 360,106 C480,72 560,122 680,84 C800,48 880,94 960,66',
];

const Contours = ({ light = false, className = '' }) => {
  const stroke = light ? 'rgba(111,179,126,0.55)' : 'rgba(26,106,68,0.35)';
  const pulse = light ? '#C4901F' : '#C4901F';
  return (
    <svg
      className={`contours ${className}`}
      viewBox="0 0 960 340"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      {paths.map((d, i) => (
        <path
          key={i}
          d={d}
          stroke={stroke}
          strokeWidth={i === 2 ? 1.8 : 1.1}
          strokeOpacity={0.35 + i * 0.13}
          className="contour-line"
          style={{ animationDelay: `${i * 0.35}s` }}
        />
      ))}
      {/* data pulse travelling the mid contour */}
      <circle r="4.5" fill={pulse} className="contour-pulse">
        <animateMotion
          dur="14s"
          repeatCount="indefinite"
          path={paths[2]}
        />
      </circle>
    </svg>
  );
};

export default Contours;
